import { render, staticRenderFns } from "./EmploymentContractList.vue?vue&type=template&id=b00bb05e&scoped=true"
import script from "./EmploymentContractList.vue?vue&type=script&lang=js"
export * from "./EmploymentContractList.vue?vue&type=script&lang=js"
import style0 from "./EmploymentContractList.vue?vue&type=style&index=0&id=b00bb05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00bb05e",
  null
  
)

export default component.exports